<div *ngIf="showMaintenance" id="maintenance" class="unselectable">
  {{this.translation.MaintenancePart1}} {{this.date}} {{this.translation.MaintenancePart2}} {{this.time}} {{this.translation.MaintenancePart3}}
  <span id="closeMaintenance" class="material-icons" (click)="closeMaintenance()">close</span>
</div>
